module.exports = __webpack_public_path__ + "img/magnifying-glass-right.c4c2b268.svg";